import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=66ce13c6&"
import script from "./Snackbar.vue?vue&type=script&lang=js&"
export * from "./Snackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ce13c6')) {
      api.createRecord('66ce13c6', component.options)
    } else {
      api.reload('66ce13c6', component.options)
    }
    module.hot.accept("./Snackbar.vue?vue&type=template&id=66ce13c6&", function () {
      api.rerender('66ce13c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/Snackbar.vue"
export default component.exports